import { useEffect, useState } from "react";
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim"; 

const LeafParticles = () => {
  const [init, setInit] = useState(false);

  // Khởi tạo engine của particles
  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadSlim(engine);
    }).then(() => {
      setInit(true);
    });
  }, []);

  const particlesOptions = {
    particles: {
      number: { value: 45, density: { enable: true, area: 800 } },
      shape: {
        type: "image",
        options: {
          // Bạn có thể thay link ảnh lá khác ở đây
          image: [
            { src: "/imges/yellow-1.png", width: 32, height: 32 },
            { src: "/imges/yellow.png", width: 32, height: 32 }
          ],
        },
      },
      opacity: { value: 1 },
      size: { value: { min: 15, max: 25 } },
      move: {
        enable: true,
        speed: 2.5,
        direction: "bottom", // Rơi xuống dưới
        random: true,
        straight: false, // Bay lượn tự nhiên
        outModes: { default: "out"},
      },
      rotate: {
        value: { min: 0, max: 360 },
        animation: { enable: true, speed: 2.5 }, // Xoay khi rơi
      },
   
    },
  };

  if (init) {
    return <Particles id="tsparticles" options={particlesOptions} />;
  }

  return null;
};

export default LeafParticles;